import React from 'react'
export const QlikFrame = React.memo(function QlikFrame ({ startPage }) {
  const src = '/qsjwt'
  return (
    <div className='main main--kibana'>
      <iframe src={src} className='kibana-iframe' />
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/internal-app/pages/qlik/qlikFrame.js